import { FeeItem } from '@app/features/scope-overview/model/fee-item.model'
import { createAction, props } from '@ngrx/store'
import { ChangeItem } from '../../model'

export enum ChangeRequestFeeActionTypes {
  ADD_DELIVERABLE_FEE = '[Change Request] Add Deliverable Fee',
  ADD_DELIVERABLE_FEE_SUCCESS = '[Change Request] Add Deliverable Fee Success',
  ADD_DELIVERABLE_FEE_FAIL = '[Change Request] Add Deliverable Fee Fail',
  UPDATE_FEE_ITEM = '[Change Request] Update Fee Item',
  UPDATE_FEE_ITEM_SUCCESS = '[Change Request] Update Fee Item Success',
  UPDATE_FEE_ITEM_FAIL = '[Change Request] Update Fee Item Fail',
  ADD_SCOPE_FEE = '[Change Request] Add Scope Fee',
  ADD_SCOPE_FEE_SUCCESS = '[Change Request] Add Scope Fee Success',
  ADD_SCOPE_FEE_FAIL = '[Change Request] Add Scope Fee Fail',
  DELETE_SCOPE_FEE = '[Change Request] Delete Scope Fee',
  DELETE_SCOPE_FEE_SUCCESS = '[Change Request] Delete Scope Fee Success',
  DELETE_SCOPE_FEE_FAIL = '[Change Request] Delete Scope Fee Fail',
}

const addDeliverableFee = createAction(
  ChangeRequestFeeActionTypes.ADD_DELIVERABLE_FEE,
  props<{ identity: number; parentId: number; data: FeeItem }>()
)
const addDeliverableFeeSuccess = createAction(
  ChangeRequestFeeActionTypes.ADD_DELIVERABLE_FEE_SUCCESS,
  props<{ changeItem: ChangeItem }>()
)
const addDeliverableFeeFail = createAction(
  ChangeRequestFeeActionTypes.ADD_DELIVERABLE_FEE_FAIL,
  props<{ error: Error }>()
)

const updateFeeItem = createAction(
  ChangeRequestFeeActionTypes.UPDATE_FEE_ITEM,
  props<{ feeItemId: number; data: FeeItem }>()
)
const updateFeeItemSuccess = createAction(
  ChangeRequestFeeActionTypes.UPDATE_FEE_ITEM_SUCCESS,
  props<{ changeItem: ChangeItem }>()
)
const updateFeeItemFail = createAction(ChangeRequestFeeActionTypes.UPDATE_FEE_ITEM_FAIL, props<{ error: Error }>())

const addScopeFee = createAction(ChangeRequestFeeActionTypes.ADD_SCOPE_FEE, props<{ data: FeeItem }>())
const addScopeFeeSuccess = createAction(
  ChangeRequestFeeActionTypes.ADD_SCOPE_FEE_SUCCESS,
  props<{ changeItem: ChangeItem }>()
)
const addScopeFeeFail = createAction(ChangeRequestFeeActionTypes.ADD_SCOPE_FEE_FAIL, props<{ error: Error }>())

const deleteScopeFee = createAction(ChangeRequestFeeActionTypes.DELETE_SCOPE_FEE, props<{ feeItemId: number }>())
const deleteScopeFeeSuccess = createAction(
  ChangeRequestFeeActionTypes.DELETE_SCOPE_FEE_SUCCESS,
  props<{ changeItem: ChangeItem }>()
)
const deleteScopeFeeFail = createAction(ChangeRequestFeeActionTypes.DELETE_SCOPE_FEE_FAIL, props<{ error: Error }>())

export const ChangeRequestFeeActions = {
  addDeliverableFee,
  addDeliverableFeeSuccess,
  addDeliverableFeeFail,
  updateFeeItem,
  updateFeeItemSuccess,
  updateFeeItemFail,
  addScopeFee,
  addScopeFeeSuccess,
  addScopeFeeFail,
  deleteScopeFee,
  deleteScopeFeeSuccess,
  deleteScopeFeeFail,
}
